import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Typography } from "@mui/material";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Sidebar from "../components/sidebar/Sidebar-old";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useForm } from "react-hook-form";
import { getDiscoveryMarketByPartner } from "../../API/endpoints/Discovery";
import {
  addDueDiligence,
  getDueDiligenceByID,
  updateDueDiligence,
} from "../../API/endpoints/DueDIligence";
import BreadCrumb from "../components/header/BreadCrumb";
import { getPartnerByID, updatePartner } from "../../API/endpoints/Partner";

const DueDiligenceAdd = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [breadCrumbData, setBreadCrumbData] = React.useState<any>([]);
  const [marketList, setMarketList] = React.useState([]);
  const [selectedMarket, setSelectedMarket] = React.useState("");
  const [partnerName, setPartnerName] = React.useState("");
  const [availableServices, setAvailableServices] = React.useState<string[]>(
    []
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      market_id: "",
      region: params?.countryId,
      regulatory_compliance_rating: undefined,
      regulatory_compliance_remarks: "",
      warehousing_storage_rating: undefined,
      warehousing_storage_remarks: "",
      retail_distribuion_rating: undefined,
      retail_distribuion_remarks: "",
      order_fulfillment_rating: undefined,
      order_fulfillment_remarks: "",
      importation_clearance_rating: undefined,
      importation_clearance_remarks: "",
      marketing_rating: undefined,
      marketing_remarks: "",
      responsiveness_rating: undefined,
      responsiveness_remarks: "",
      ecom_setup_and_management_rating: undefined,
      ecom_setup_and_management_remarks: "",
      evaluation_criteria_rating: undefined,
      evaluation_criteria_remarks: "",
      remarks: "",
    },
  });

  useEffect(() => {
    if (params?.id) {
      getDueDiligenceByID(params?.id)
        .then((res) => {
          let data = res.data;
          onChangeMarket(data?.market_id);

          let editData = {
            market_id: data?.market_id,
            region: data?.region,
            regulatory_compliance_rating: data?.regulatory_compliance_rating
              ? data.regulatory_compliance_rating
              : undefined,
            regulatory_compliance_remarks: data?.regulatory_compliance_remarks
              ? data.regulatory_compliance_remarks
              : undefined,
            warehousing_storage_rating: data?.warehousing_storage_rating
              ? data.warehousing_storage_rating
              : undefined,
            warehousing_storage_remarks: data?.warehousing_storage_remarks
              ? data.warehousing_storage_remarks
              : undefined,
            retail_distribuion_rating: data?.retail_distribuion_rating
              ? data.retail_distribuion_rating
              : undefined,
            retail_distribuion_remarks: data?.retail_distribuion_remarks
              ? data.retail_distribuion_remarks
              : undefined,
            order_fulfillment_rating: data?.order_fulfillment_rating
              ? data.order_fulfillment_rating
              : undefined,
            order_fulfillment_remarks: data?.order_fulfillment_remarks
              ? data.order_fulfillment_remarks
              : undefined,
            importation_clearance_rating: data?.importation_clearance_rating
              ? data.importation_clearance_rating
              : undefined,
            importation_clearance_remarks: data?.importation_clearance_remarks
              ? data.importation_clearance_remarks
              : undefined,
            marketing_rating: data?.marketing_rating
              ? data.marketing_rating
              : undefined,
            marketing_remarks: data?.marketing_remarks
              ? data.marketing_remarks
              : undefined,
            responsiveness_rating: data?.responsiveness_rating
              ? data.responsiveness_rating
              : undefined,
            responsiveness_remarks: data?.responsiveness_remarks
              ? data.responsiveness_remarks
              : undefined,
            ecom_setup_and_management_rating:
              data?.ecom_setup_and_management_rating
                ? data.ecom_setup_and_management_rating
                : undefined,
            ecom_setup_and_management_remarks:
              data?.ecom_setup_and_management_remarks
                ? data.ecom_setup_and_management_remarks
                : undefined,
            evaluation_criteria_rating: data?.evaluation_criteria_rating
              ? data.evaluation_criteria_rating
              : undefined,
            evaluation_criteria_remarks: data?.evaluation_criteria_remarks
              ? data.evaluation_criteria_remarks
              : undefined,
            remarks: data?.remarks ? data.remarks : undefined,
          };
          reset(editData);
          setSelectedMarket(data?.market_id);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [params, marketList]);

  useEffect(() => {
    if (params?.partnerId && params?.countryId) {
      const marketReq = {
        partner_id: params?.partnerId,
        country: params?.countryId,
      };
      getDiscoveryMarketByPartner(marketReq)
        .then((res) => {
          console.log("market", res.data);
          setMarketList(
            res.data.rows.map((item: any, index: number) => {
              if (index == 0) {
                setPartnerName(item?.partnerv2?.name);
              }
              return { id: item.id, name: item?.country?.name, region: item };
            })
          );
        })
        .catch((err) => console.log("err", err));
    } else if (params?.partnerId) {
      getPartnerByID(params?.partnerId).then((res: any) => {
        setPartnerName(res.data?.name);
        setMarketList(
          res.data.market.map((item: any, index: number) => {
            return {
              id: item.id,
              name: item?.country?.name,
              region: item?.region,
              service_capabilities: item?.service_capabilities,
              disabled: item?.due_diigence?.length > 0,
            };
          })
        );
      });
    }
  }, [params]);

  const onSubmit = (data: any) => {
    if (!Boolean(selectedMarket)) {
      setError("market_id", {
        type: "custom",
        message: "* This field is required",
      });
      return;
    }

    const region: any = marketList.find(
      (item: any) => item.id === selectedMarket
    );

    const req = {
      ...data,
      region: region?.region,
      market_id: selectedMarket,
      regulatory_compliance_rating: data?.regulatory_compliance_rating
        ? data.regulatory_compliance_rating
        : undefined,
      regulatory_compliance_remarks: data?.regulatory_compliance_remarks
        ? data.regulatory_compliance_remarks
        : undefined,
      warehousing_storage_rating: data?.warehousing_storage_rating
        ? data.warehousing_storage_rating
        : undefined,
      warehousing_storage_remarks: data?.warehousing_storage_remarks
        ? data.warehousing_storage_remarks
        : undefined,
      retail_distribuion_rating: data?.retail_distribuion_rating
        ? data.retail_distribuion_rating
        : undefined,
      retail_distribuion_remarks: data?.retail_distribuion_remarks
        ? data.retail_distribuion_remarks
        : undefined,
      order_fulfillment_rating: data?.order_fulfillment_rating
        ? data.order_fulfillment_rating
        : undefined,
      order_fulfillment_remarks: data?.order_fulfillment_remarks
        ? data.order_fulfillment_remarks
        : undefined,
      importation_clearance_rating: data?.importation_clearance_rating
        ? data.importation_clearance_rating
        : undefined,
      importation_clearance_remarks: data?.importation_clearance_remarks
        ? data.importation_clearance_remarks
        : undefined,
      marketing_rating: data?.marketing_rating
        ? data.marketing_rating
        : undefined,
      marketing_remarks: data?.marketing_remarks
        ? data.marketing_remarks
        : undefined,
      responsiveness_rating: data?.responsiveness_rating
        ? data.responsiveness_rating
        : undefined,
      responsiveness_remarks: data?.responsiveness_remarks
        ? data.responsiveness_remarks
        : undefined,
      ecom_setup_and_management_rating: data?.ecom_setup_and_management_rating
        ? data.ecom_setup_and_management_rating
        : undefined,
      ecom_setup_and_management_remarks: data?.ecom_setup_and_management_remarks
        ? data.ecom_setup_and_management_remarks
        : undefined,
      evaluation_criteria_rating: data?.evaluation_criteria_rating
        ? data.evaluation_criteria_rating
        : undefined,
      evaluation_criteria_remarks: data?.evaluation_criteria_remarks
        ? data.evaluation_criteria_remarks
        : undefined,
      remarks: data?.remarks ? data.remarks : undefined,
    };

    if (params?.id) {
      updateDueDiligence(params?.id, req)
        .then((res) => {
          navigate(-1);
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      addDueDiligence(req)
        .then((res) => {
          if (params?.toComplete && params?.toComplete === "true") {
            const reqData = {
              status: "DUE_DILIGENCE_COMPLETED",
            };

            const statusUpdate = updatePartner(reqData, params?.partnerId);
          }

          navigate(-1);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const onChangeMarket = (value: any) => {
    setSelectedMarket(value);
    const market: any = marketList.find((item: any) => item?.id === value);
    setAvailableServices(
      market?.service_capabilities ? market?.service_capabilities : []
    );

    if (!Boolean(value)) {
      setError("market_id", {
        type: "custom",
        message: "* This field is required",
      });
    } else {
      clearErrors("market_id");
    }
  };

  const markets = useMemo(() => {
    return marketList.map((item: any) => {
      return (
        <MenuItem value={item?.id} disabled={item?.disabled}>
          {item?.name}
        </MenuItem>
      );
    });
  }, [marketList]);

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        onSubmit(data);
      })}
    >
      <Container fluid className="adminusers">
        <Row className="row">
          <Col className="sidebar">
            <Sidebar active="discovery" />
          </Col>
          <Col>
            <Container fluid className="container-1 mt-32px">
              <Row>
                <Col className="breadcrumb-nav">
                  {/* <BreadCrumb breadcrumbData={breadCrumbData} /> */}
                  <Breadcrumb>
                    {params?.partnerId && params?.countryId ? (
                      <>
                        <Breadcrumb.Item
                          className="font12-regular gray-500"
                          onClick={() => navigate(-4)}
                        >
                          DISCOVERY MANAGEMENT
                        </Breadcrumb.Item>
                        <Breadcrumb.Item
                          className="font12-regular gray-500"
                          onClick={() => navigate(-3)}
                        >
                          {params?.brandName}
                        </Breadcrumb.Item>
                      </>
                    ) : (
                      <Breadcrumb.Item className="font12-regular gray-500">
                        <Link to="/PartnerManagement">Partner MANAGEMENT</Link>
                      </Breadcrumb.Item>
                    )}

                    <Breadcrumb.Item
                      className="font12-medium gray-800"
                      onClick={() => {
                        if (params?.partnerId && params?.countryId) {
                          navigate(-2);
                        } else {
                          navigate(`/partner/${params?.partnerId}`);
                        }
                      }}
                    >
                      {partnerName}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="font12-medium gray-800"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      due diligence
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="font12-medium gray-800" active>
                      {params?.id ? "edit" : "add"} due diligence
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
              </Row>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              ></Grid>
              <Row className="mb12px pt24px bt-gray200">
                <Col sm={3} md={3} lg={3}>
                  <FormControl sx={{ minWidth: "100%" }} size="small">
                    <label>Market</label>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="Age"
                      value={selectedMarket}
                      onChange={(e) => onChangeMarket(e.target.value)}
                    >
                      {markets}
                    </Select>
                    <Form.Text muted>
                      <span>
                        <p className="error-form">
                          {errors.market_id?.message}
                        </p>
                      </span>
                    </Form.Text>
                  </FormControl>
                </Col>
              </Row>
              <Accordion defaultExpanded>
                <Row className=" row-input pl20px">
                  <Col sm={3} md={3} lg={3}>
                    <Row className="my-8">
                      <Typography
                        sx={{
                          fontWeight: "500",
                          color: "#344054",
                          fontSize: "14px",
                        }}
                      >
                        Basis
                      </Typography>
                    </Row>
                  </Col>
                  <Col sm={2} md={2} lg={2}>
                    <Row className="my-8">
                      <Typography
                        sx={{
                          fontWeight: "500",
                          color: "#344054",
                          fontSize: "14px",
                        }}
                      >
                        Rating out of 10
                      </Typography>
                    </Row>
                  </Col>
                  <Col sm={7} md={7} lg={7}>
                    <Row className="my-8">
                      <Typography
                        sx={{
                          fontWeight: "500",
                          color: "#344054",
                          fontSize: "14px",
                        }}
                      >
                        Remarks
                      </Typography>
                    </Row>
                  </Col>
                </Row>
                <AccordionDetails className="bt-gray200">
                  {availableServices.includes("regulatory_compliance") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Regulatory Compliance
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("regulatory_compliance_rating", {
                                max: 10,
                              })}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.regulatory_compliance_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("regulatory_compliance_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {
                                    errors.regulatory_compliance_remarks
                                      ?.message
                                  }
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("warehousing_storage") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Warehousing and Storage
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("warehousing_storage_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.warehousing_storage_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("warehousing_storage_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.warehousing_storage_remarks?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("retail_distribution") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Retail Distribution
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("retail_distribuion_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.retail_distribuion_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("retail_distribuion_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.retail_distribuion_remarks?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("order_fulfilment") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Order Fulfillment
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("order_fulfillment_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.order_fulfillment_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("order_fulfillment_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.order_fulfillment_remarks?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("importation_clearance") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Importance and Clearance
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("importation_clearance_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.importation_clearance_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("importation_clearance_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {
                                    errors.importation_clearance_remarks
                                      ?.message
                                  }
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("marketing") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            Marketing
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("marketing_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.marketing_rating?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("marketing_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {errors.marketing_remarks?.message}
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {availableServices.includes("ecom_setup_mgmt") && (
                    <Row className="row-input pl8px">
                      <Col sm={3} md={3} lg={3}>
                        <Row className="my-8">
                          <Typography
                            sx={{
                              fontWeight: "500",
                              color: "#344054",
                              fontSize: "14px",
                            }}
                          >
                            E-Commerce Setup and Management
                          </Typography>
                        </Row>
                      </Col>
                      <Col sm={2} md={2} lg={2}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="number"
                              placeholder=" "
                              {...register("ecom_setup_and_management_rating")}
                              step={0.1}
                              max={10}
                              min={0}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {
                                    errors.ecom_setup_and_management_rating
                                      ?.message
                                  }
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                      <Col sm={7} md={7} lg={7}>
                        <Row className="my-8">
                          <Form.Group
                            className="formgroup mr12px"
                            controlId="formCompanyName"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Add Remarks"
                              {...register("ecom_setup_and_management_remarks")}
                            />

                            <Form.Text muted>
                              <span>
                                <p className="error-form">
                                  {
                                    errors.ecom_setup_and_management_remarks
                                      ?.message
                                  }
                                </p>
                              </span>
                            </Form.Text>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  <Row className="my-8 pl8px">
                    <Typography
                      sx={{
                        fontWeight: "600",
                        color: "#344054",
                        fontSize: "14px",
                      }}
                    >
                      Qualitative Analysis
                    </Typography>
                  </Row>
                  <Row className="row-input pl8px">
                    <Col sm={3} md={3} lg={3}>
                      <Row className="my-8">
                        <Typography
                          sx={{
                            fontWeight: "500",
                            color: "#344054",
                            fontSize: "14px",
                          }}
                        >
                          Responsiveness
                        </Typography>
                      </Row>
                    </Col>
                    <Col sm={2} md={2} lg={2}>
                      <Row className="my-8">
                        <Form.Group
                          className="formgroup mr12px"
                          controlId="formCompanyName"
                        >
                          <Form.Control
                            type="number"
                            placeholder=" "
                            {...register("responsiveness_rating")}
                            step={0.1}
                            max={10}
                            min={0}
                          />

                          <Form.Text muted>
                            <span>
                              <p className="error-form">
                                {errors.responsiveness_rating?.message}
                              </p>
                            </span>
                          </Form.Text>
                        </Form.Group>
                      </Row>
                    </Col>
                    <Col sm={7} md={7} lg={7}>
                      <Row className="my-8">
                        <Form.Group
                          className="formgroup mr12px"
                          controlId="formCompanyName"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Add Remarks"
                            {...register("responsiveness_remarks")}
                          />

                          <Form.Text muted>
                            <span>
                              <p className="error-form">
                                {errors.responsiveness_remarks?.message}
                              </p>
                            </span>
                          </Form.Text>
                        </Form.Group>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="row-input pl8px">
                    <Col sm={3} md={3} lg={3}>
                      <Row className="my-8">
                        <Typography
                          sx={{
                            fontWeight: "500",
                            color: "#344054",
                            fontSize: "14px",
                          }}
                        >
                          Evaluation Criteria
                        </Typography>
                      </Row>
                    </Col>
                    <Col sm={2} md={2} lg={2}>
                      <Row className="my-8">
                        <Form.Group
                          className="formgroup mr12px"
                          controlId="formCompanyName"
                        >
                          <Form.Control
                            type="number"
                            placeholder=" "
                            {...register("evaluation_criteria_rating")}
                            step={0.1}
                            max={10}
                            min={0}
                          />

                          <Form.Text muted>
                            <span>
                              <p className="error-form">
                                {errors.evaluation_criteria_rating?.message}
                              </p>
                            </span>
                          </Form.Text>
                        </Form.Group>
                      </Row>
                    </Col>
                    <Col sm={7} md={7} lg={7}>
                      <Row className="my-8">
                        <Form.Group
                          className="formgroup mr12px"
                          controlId="formCompanyName"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Add Remarks"
                            {...register("evaluation_criteria_remarks")}
                          />

                          <Form.Text muted>
                            <span>
                              <p className="error-form">
                                {errors.evaluation_criteria_remarks?.message}
                              </p>
                            </span>
                          </Form.Text>
                        </Form.Group>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="mb16px">
                    <Col sm={12} lg={12} xl={12}>
                      <Form.Group controlId="">
                        <label>Remarks</label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="sample text"
                          {...register("remarks")}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </AccordionDetails>
              </Accordion>
            </Container>
          </Col>
        </Row>
      </Container>
      <Container fluid className="bt-gray200 mt40px">
        <Row className="justify-content-end mb-3 mt-4">
          <Col className="d-flex justify-content-end">
            <Link to="/PartnerManagement" className="m-1">
              <Button variant="secondary" className="btn-secondary12">
                Cancel
              </Button>
            </Link>
            <Button
              variant="primary"
              className="btn-primary12 m-1"
              type="submit"
            >
              {params?.id ? "Update" : "Save and continue"}
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default DueDiligenceAdd;
